import * as React from 'react';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import { CheckPermissions, DownloadFile, GetQuery } from './Shared';
import type { GenericList } from './models/JobSharedInterfaces';

const ReportCustomerPricelistData = () => {
    let navigate = useNavigate();
    const [loading, setLoading] = React.useState(true);
    const [pricelistOptions, setPricelistOptions] = React.useState<GenericList[]>([]);
    const [pricelistTierId, setPricelistTierId] = React.useState(-1);
    const [errors, setErrors] = React.useState<{ [key: string]: string }>({});

    React.useEffect(() => {
        getData();
    }, [])

    const getData = async () => {
        var hasPermission = await CheckPermissions("RunReports");
        if (hasPermission) {
            getCustPricelistTiers();
        } else {
            navigate("/accessdenied");
        }
    }

    const getCustPricelistTiers = async () => {
        const apiUrl = "GetCustomerPricelistTiers";
        var result = await GetQuery(apiUrl);

        if (result.error) {
            toast.error("Error getting data!");
        } else {
            setPricelistOptions(result.data);
            setLoading(false);
        }
    }

    const validate = () => {
        let errorList: any = {};
        let formIsValid = true;

        if (pricelistTierId < 0) {
            formIsValid = false;
            errorList["pricelistTierId"] = "Price List is required";
        }

        setErrors(errorList);
        return formIsValid;
    }

    const exportReport = (e: any) => {
        e.preventDefault();
        //run the report and export the data
        if (validate()) {
            exportRpt();
        }
    }
 
    const exportRpt = async () => {
        const apiURL = 'ExportCustomerPriceListTierReportData?PriceListTierId=' + pricelistTierId;
        var filename = "Customers with Pricelist.xlsx";
        await DownloadFile(apiURL, filename);
    }

    const renderDetails = (
        <div>
            <div className="marginBottom20">
                <h1>Customers with Pricelist Report</h1>
                <div>This report will show all customers setup with the selected pricelist.</div>
                <div>Note: Tier 1 won't show many customers as this is the default pricelist so doesn't need to be selected.</div>
            </div>
            <div>
                <label className="input-group" htmlFor="pricelistTierId">
                    <span className="label">Pricelist</span>
                    <select className="select" id="pricelistTierId" name="pricelistTierId" value={pricelistTierId} onChange={(e) => setPricelistTierId(Number(e.target.value))}>
                        <option defaultValue="-1" value="-1"></option>
                        {pricelistOptions.map(item =>
                            <option key={item.id} value={item.id}>{item.name}</option>
                        )};
                    </select>
                </label>

                <span className={errors["pricelistTierId"] ? "label errors marginLeftLabel" : "hidden"}>{errors["pricelistTierId"]}</span>
            </div>
            <div>
                <button className="defaultbutton marginLeftLabel" type='button' onClick={exportReport}>Export To Excel</button>
            </div>
        </div>
    );

    let contents = loading
        ? <p><em>Loading...</em></p>
        : renderDetails;

    return (<div>
        {contents}
    </div>)

};

export default ReportCustomerPricelistData;